// Espejo de las rutas reales registradas en src/App.js (atributos `path` de cada <Route>).
// Fuente de verdad: App.js. Si se agrega/quita/renombra una ruta allí, actualizar acá.
//
// Se usa para validar "subir un nivel" (ver src/utils/getParentPath.js): el helper sube al
// ancestro real más cercano que matchee una de estas rutas. Por eso incluye los patrones con
// parámetros (`:id`) tal cual están en App.js — matchRoutes los resuelve correctamente y así
// un candidato como "/admin/factura" NO matchea "/admin/factura/:oportunidadId".
//
// Se excluyen deliberadamente: la ruta index "/", el catch-all "*" y "/login" (no son
// ancestros navegables de la jerarquía; el piso de "subir nivel" es "/admin").

export const APP_ROUTE_PATHS = [
  // --- Públicas ---
  "/auth/confirm",
  "/bitcoinapi",
  "/categorias/automotriz",
  "/categorias/bebidas",
  "/categorias/belleza",
  "/categorias/fastfood",
  "/categorias/delivery",
  "/categorias/smartphones",
  "/categorias/inversiones",
  "/categorias/mascotas",
  "/categorias/perfumes",
  "/categorias/retail",
  "/categorias/telcos",
  "/categorias/transporte",
  "/categorias/vacaciones",
  "/categorias/viajes",
  "/categorias/vestimenta",
  "/agencias",
  "/edificios",
  "/ficha-edificio/:id",
  "/galeria",
  "/intro",
  "/inventario",
  "/landing",
  "/listadoempresas",
  "/listadovetos",
  "/mapa",
  "/mediakit",
  "/mediakit-edificios-full",
  "/mediakit-edificios-full-cbre",
  "/investigacion-ipsos",
  "/simulador-impacto",
  "/portafolio",
  "/redirect",
  "/td",
  "/transformacion-digital",
  "/transformacion-digital-ventas",
  "/carteleriiaa",
  // --- Privadas /admin/* + /categorias ---
  "/admin",
  "/admin/er",
  "/admin/er-v2",
  "/admin/cargar-cliente",
  "/admin/cargar-factura",
  "/admin/cargar-oportunidad",
  "/admin/factura/:oportunidadId",
  "/admin/oportunidades/editar/:oportunidadId",
  "/admin/informes-comision",
  "/admin/online-cotizador",
  "/admin/mis-cotizaciones",
  "/admin/reporte-fotografico",
  "/admin/reporte-fotografico-externo",
  "/admin/carteleriiaa",
  "/admin/online-cotizador/editar/:id",
  "/admin/ventas-BTL",
  "/admin/perfil",
  "/admin/usuarios",
  // Hub de ventas (/admin/ventas/*): las 6 visualizaciones son las rutas navegables reales.
  // A propósito NO se lista "/admin/ventas": si estuviera, el click en el logo desde
  // "/admin/ventas/pizarra" subiría a "/admin/ventas" (que es un redirect a "/admin/ventas/pizarra")
  // y quedaría atrapado en el mismo lugar. Omitiéndola, getParentPath sube derecho a "/admin".
  "/admin/ventas/pizarra",
  "/admin/ventas/detalle",
  "/admin/ventas/crm",
  "/admin/ventas/mapa-calor",
  "/admin/ventas/cotizaciones",
  "/admin/ventas/categorias",
  "/admin/ventas-facturas",
  "/admin/facturacion",
  "/admin/ventas-proyeccion",
  "/admin/mis-ventas-baca",
  "/admin/gestion-activos",
  "/admin/flujo-caja",
  "/admin/flujo-caja-old",
  "/admin/dashboard-financiero",
  "/admin/dashboard-iva",
  "/admin/estado-cuenta",
  "/admin/factoring",
  "/admin/creditos",
  "/admin/conciliacion-sii",
  "/admin/movimientos-bancarios",
  "/admin/cuentas-bancarias",
  "/admin/mis-facturas",
  "/admin/ventas-region",
  "/admin/edificios",
  "/categorias",
  "/admin/cotizaciones",
  "/admin/clientes",
  "/admin/clientes-cartera",
  "/admin/mailing",
  "/admin/gestion-empleados",
  "/admin/proveedores",
];
